import { ActionType, getType } from 'typesafe-actions';

import * as config from '../../actionCreators/config';

export default function (
  state: EftposConfig = {},
  action: ActionType<typeof config>,
): EftposConfig {
  switch (action.type) {
    case getType(config.setEftposConfig): {
      const { value } = action.payload;
      return { ...state, ...value };
    }
    default:
      return state;
  }
}
